import { IDOrganizacaoInterface } from "../../Interfaces/Organizacao/Organizacao";
import Axios from "../Config/API";
import Service from "../Service";

export async function GetOrganizacaoService() {
    return Service(
        Axios.get<IDOrganizacaoInterface>(`/home/organizacao/getorganizacao`)
    );
}
